import { ReactComponent as FlagIcon } from "./svg/co-flag.svg";
import "../flag-icon.scss";

export const COFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
